import React from "react"
import { IconSeeker } from "@ui-seeker/core"
import { AppBulkEditAction, AppDialogCancel } from "@components"
import { autoEuropeSeasonSetsDrawerErrors, clearAutoEuropeSeasonSetsSignals } from "Pages/AutoEuropeTool/SeasonSets/@signals"

export default function AutoEuropeSeasonSetsFooter({ onSubmit, isLoading }) {
	return <>
		<AppDialogCancel onClick={clearAutoEuropeSeasonSetsSignals}/>
		<AppBulkEditAction
			loading={isLoading}
			startIcon={<IconSeeker icon="floppy-disk"/>}
			disabled={!Object.values(autoEuropeSeasonSetsDrawerErrors.value).every(a => a)}
			onClick={onSubmit}
		>
			Save
		</AppBulkEditAction>
	</>
}
